import type { Locale } from '@xdocs/i18n';

/**
 * STOP-GAP local catalog for the `adminCms:` scope (F61), following the
 * `shares:`/`search:` precedent — see `apps/web/src/routes/shares/shares.i18n.ts`.
 * NOT a second i18n runtime (E18/§13.3 ban); `packages/i18n/**` is outside
 * this task's ownership.
 *
 * OPEN ISSUE: fold into `packages/i18n/src/catalogs/{en,ro}/admin.json`.
 */
const en = {
  'page.title': 'Landing CMS',
  'page.description': 'Edit the landing site’s copy. Changes are versioned, localized, and published to the live site.',
  'blockList.title': 'Blocks',
  'blockList.searchPlaceholder': 'Search block keys…',
  'blockList.empty.title': 'No landing blocks yet',
  'blockList.empty.description': 'Blocks appear here once the landing content is seeded.',
  'blockList.error.title': "Couldn't load landing blocks.",
  'blockList.newBlock.label': 'New block key',
  'blockList.newBlock.placeholder': 'e.g. hero.headline',
  'blockList.newBlock.add': 'Add',
  'blockList.status.draft': 'Draft v{version}',
  'blockList.status.published': 'Published v{version}',
  'blockList.status.missing': 'Not created',
  'editor.title': 'Editing “{blockKey}”',
  'editor.field.content': 'Content (HTML)',
  'editor.field.content.hint': 'Saved content is sanitized server-side before it can be published (E4/§26).',
  'editor.action.saveDraft': 'Save draft',
  'editor.action.publish': 'Publish',
  'editor.publish.disabledReason.noDraft': 'Save a draft for this locale before publishing.',
  'editor.publish.disabledReason.unsavedChanges': 'Save your changes before publishing this version.',
  'editor.preview.title': 'Preview',
  'editor.preview.unsaved': 'Save a draft to see the sanitized preview.',
  'editor.history.title': 'Version history',
  'editor.history.unavailable': 'Version history isn’t available yet for this block.',
  'confirm.publish.action': 'Publish',
  'confirm.publish.description': 'Makes this the live version on the landing site immediately.',
  'toast.draftSaved.action': 'Draft saved',
  'toast.published.action': 'Published',
} as const;

const ro = {
  'page.title': 'CMS pagină principală',
  'page.description': 'Editează textele site-ului principal. Modificările sunt versionate, localizate și publicate pe site-ul live.',
  'blockList.title': 'Blocuri',
  'blockList.searchPlaceholder': 'Caută chei de bloc…',
  'blockList.empty.title': 'Niciun bloc încă',
  'blockList.empty.description': 'Blocurile apar aici după ce conținutul paginii principale este populat.',
  'blockList.error.title': 'Nu am putut încărca blocurile.',
  'blockList.newBlock.label': 'Cheie bloc nouă',
  'blockList.newBlock.placeholder': 'ex. hero.headline',
  'blockList.newBlock.add': 'Adaugă',
  'blockList.status.draft': 'Ciornă v{version}',
  'blockList.status.published': 'Publicat v{version}',
  'blockList.status.missing': 'Neconceput',
  'editor.title': 'Editezi „{blockKey}”',
  'editor.field.content': 'Conținut (HTML)',
  'editor.field.content.hint': 'Conținutul salvat este curățat pe server înainte de a putea fi publicat (E4/§26).',
  'editor.action.saveDraft': 'Salvează ciorna',
  'editor.action.publish': 'Publică',
  'editor.publish.disabledReason.noDraft': 'Salvează o ciornă pentru această limbă înainte de publicare.',
  'editor.publish.disabledReason.unsavedChanges': 'Salvează modificările înainte de a publica această versiune.',
  'editor.preview.title': 'Previzualizare',
  'editor.preview.unsaved': 'Salvează o ciornă pentru a vedea previzualizarea curățată.',
  'editor.history.title': 'Istoric versiuni',
  'editor.history.unavailable': 'Istoricul versiunilor nu este încă disponibil pentru acest bloc.',
  'confirm.publish.action': 'Publică',
  'confirm.publish.description': 'Face din aceasta versiunea live pe pagina principală, imediat.',
  'toast.draftSaved.action': 'Ciornă salvată',
  'toast.published.action': 'Publicat',
} as const;

export const ADMIN_CMS_CATALOG: Record<Locale, Record<AdminCmsCatalogKey, string>> = { en, ro };
export type AdminCmsCatalogKey = keyof typeof en;
